import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import * as Utils from "../../inc/Utils";

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import DatePicker from "react-datepicker";
import Select from 'react-select'
import {getOwnerRunningId} from "../../inc/Utils";
import {getOwnerRunningCode} from "../../inc/Utils";

export default function UtmGenerateSingle() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [type, setType] = React.useState('');
    let [lang, setLanguage] = React.useState('');
    let [projectType, setProjectType] = React.useState('');
    let [project, setProject] = React.useState('');
    let [campaign, setCampaign] = React.useState('');
    let [campaignType, setCampaignType] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [promotion, setPromotion] = React.useState('');
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    const navigate = useNavigate();

    let [campaignDate, setCampaignDate] = React.useState('');
    let [typeId, setTypeId] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [projectId, setProjectId] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);
    let [promotionId, setPromotionId] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [promotionPlaceholder, setPromotionPlaceholder] = React.useState('...');
    let [disableProject, setDisableProject] = React.useState(true);
    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [disablePromotion, setDisablePromotion] = React.useState(true);
    let [templateSource, setTemplateSource] = React.useState('');
    let [utm, setUtm] = React.useState('');
    let [showUTMListing, setShowUtmListing] = React.useState(false);
    let [contentId, setContentId] = React.useState('');
    let [ownerId, setOwnerId] = React.useState('');
    let [previewing, setPreviewing] = React.useState(false);
    let [preview, setPreview] = React.useState(false);
    let [hashtagList, setHashtagList] = React.useState('');
    let [hashtag, setHashtag] = React.useState(null);

    let [disableMasterUrl, setDisableMasterUrl] = React.useState(true);
    let [masterUrlPlaceholder, setMasterUrlPlaceholder] = React.useState('...');
    let [masterUrl, setMasterUrl] = React.useState(null);
    let [masterUrlId, setMasterUrlId] = React.useState(null);
    let [masterUrlText, setMasterUrlText] = React.useState(null);

    let [showProjectMasterURL, setShowProjectMasterURL] = React.useState(false);
    let [projectMasterURL, setProjectMasterURL] = React.useState('');
    let [projectMasterURLPlaceholder, setProjectMasterURLPlaceholder] = React.useState('...');
    let [disableProjectMasterURL, setDisableProjectMasterURL] = React.useState(true);
    let [userAgency, setUserAgency] = React.useState(null);

    let refUrl = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);
                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);
                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);
                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);
                const resBuType = await Utils.getBuType();
                setBuType(resBuType);
                const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
                setUtmTemplate(resTemplate);
                const resRebrandly = await Utils.getRebrandly();
                setRebrandly(resRebrandly);
                const resShortIO = await Utils.getShortIO();
                setShortIO(resShortIO);
                const resHashtag = await Utils.getHashtag();
                setHashtagList(resHashtag);

                const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
                if(resAgency) {
                    setUserAgency(resAgency[0]);
                }

                //Get Project / Campaign
                if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && langId && langId.id && projectTypeId && projectTypeId.id) {
                    setProjectPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProject(proj.data);
                        setProjectPlaceholder('Select...');
                        setDisableProject(false);
                    }
                    else {
                        setProject(null);
                        setProjectPlaceholder('ไม่พบข้อมูล..');
                    }

                    if(projectId && projectId.project_code) {
                        setCampaignPlaceholder('กำลังโหลด...');
                        const camp = await Utils.getCampaign({
                            langId: langId.id,
                            projectType: projectTypeId.id,
                            projectCode: projectId.project_code,
                            campaignDate: campaignDate
                        });
                        let campaignList = [];
                        campaignList.push({
                            campaign_id: '0638A01',
                            campaign_name: 'NonDefine'
                        });
                        if(camp && camp.data) {
                            if(camp.data[0].promotions) {
                                for(let rs of camp.data[0].promotions) {
                                    campaignList.push({
                                        campaign_id: rs.campaign_id,
                                        campaign_name: rs.campaign_name
                                    });
                                }
                            }
                            setCampaignPlaceholder('Select...');
                        }
                        else {
                            setCampaignId(campaignList[0]);
                        }
                        setCampaign(campaignList);
                        setDisableCampaign(false);
                    }
                }
                //Get Promotion
                if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && langId && langId.id && campaignTypeId && campaignTypeId.id && buTypeId && buTypeId.id) {
                    setPromotionPlaceholder('กำลังโหลด...');
                    const prom = await Utils.getPromotion({
                        langId: langId.id,
                        campaignTypeId: campaignTypeId.id,
                        buTypeId: buTypeId.id,
                        campaignDate: campaignDate,
                        campaignId: campaignId ? campaignId.id : ''
                    });
                    if(prom.data) {
                        setPromotion(prom.data);
                        setPromotionPlaceholder('Select...');
                        setDisablePromotion(false);
                    }
                    else {
                        setPromotion(null);
                        setPromotionPlaceholder('ไม่พบข้อมูล..');
                    }
                }

                if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && langId && langId.id && projectTypeId && projectTypeId.id && showProjectMasterURL) {
                    setProjectMasterURLPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProjectMasterURL(proj.data);
                        setProjectMasterURLPlaceholder('Select...');
                        setDisableProjectMasterURL(false);
                    }
                    else {
                        setProjectMasterURL(null);
                        setProjectMasterURLPlaceholder('ไม่พบข้อมูล..');
                    }
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [langId, projectTypeId, projectId, campaignDate, campaignTypeId, buTypeId]);

    const onCreate = async () => {
        if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && !projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) && !projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !buTypeId) {
            toast.error("กรุณาระบุ BU Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && !masterUrlId) {
            toast.error("กรุณาระบุ Master URL");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_SPECIAL || typeId.id === Utils.GENERATE_TYPE_MASTER_URL) && !campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !promotionId) {
            toast.error("กรุณาระบุ Promotion ID");
        }
        else if(typeId && (typeId.id !== Utils.GENERATE_TYPE_MASTER_URL) && !refUrl.current.value) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(!utmTemplateId) {
            toast.error("กรุณาระบุ Template");
        }
        else if(typeId && ((typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) || typeId.id === Utils.GENERATE_TYPE_PROMOTION) && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) && !projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL) && !projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else {
            let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
            let sourceTypeIds = [];
            let ownerSelectedId = 0;
            let ownerSelectedCode = 0;
            let ownerFullText = '';
            if(selectSourceTypeIds) {
                for(let st of selectSourceTypeIds) {
                    if(st.value) {
                        let utmSourceTypeId = st.value;
                        let utmSourceId = 0;
                        let utmSourceTypeText = null;
                        let inputType = null;

                        if(utmSourceTypeId.includes(':CID')) {
                            let sp = utmSourceTypeId.split(':CID');
                            let contentId = sp[0];
                            utmSourceId = sp[1];
                            let contentView = await Utils.getContentIdView(contentId);
                            utmSourceTypeText = Utils.contentIdGenerater(contentView);
                            utmSourceTypeId = contentId;
                            inputType = Utils.API_TYPE_CONTENT_ID;
                        }
                        else if(utmSourceTypeId.includes(':OID')) {
                            let sp = utmSourceTypeId.split(':OID');
                            let ownerId = sp[0];
                            utmSourceId = sp[1];
                            let resOwner = await Utils.getOwnerView(ownerId);
                            let ownerCodeRow = await getOwnerRunningId(ownerId);
                            utmSourceTypeText = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);
                            utmSourceTypeId = ownerId;
                            inputType = Utils.API_TYPE_OWNER_ID;
                            ownerSelectedId = ownerId;
                            ownerSelectedCode = ownerCodeRow.code;
                            ownerFullText = utmSourceTypeText;
                        }
                        else if(utmSourceTypeId.includes(':CP')) {
                            let sp = utmSourceTypeId.split(':CP');
                            let campaignId = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = campaignId;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_CAMPAIGN_ID;
                        }
                        else if(utmSourceTypeId.includes(':CN')) {
                            let sp = utmSourceTypeId.split(':CN');
                            let campaignName = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = campaignName;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                        }
                        else if(utmSourceTypeId.includes(':PJI')) {
                            let sp = utmSourceTypeId.split(':PJI');
                            let projectCode = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = projectCode;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_PROJECT_ID;
                        }
                        else if(utmSourceTypeId.includes(':PJN')) {
                            let sp = utmSourceTypeId.split(':PJN');
                            let projectName = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = projectName;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_PROJECT_NAME;
                        }
                        else if(utmSourceTypeId.includes(':PJS')) {
                            let sp = utmSourceTypeId.split(':PJS');
                            let projectSlug = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = projectSlug;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_PROJECT_SLUG;
                        }
                        else if(utmSourceTypeId.includes(':PMS')) {
                            let sp = utmSourceTypeId.split(':PMS');
                            let promotionSlug = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = promotionSlug;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_PROMOTION_SLUG;
                        }
                        else if(utmSourceTypeId.includes(':LINEOA')) {
                            let sp = utmSourceTypeId.split(':LINEOA');
                            let lineOAUrl = sp[0];
                            utmSourceId = sp[1];
                            utmSourceTypeText = lineOAUrl;
                            utmSourceTypeId = 0;
                            inputType = Utils.API_TYPE_LINE_OAID;
                        }
                        else {
                            let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                            utmSourceId = sourceTypeRow.utmSourceId;
                            utmSourceTypeText = sourceTypeRow.name;
                        }

                        sourceTypeIds.push({
                            utmSourceId: utmSourceId,
                            utmSourceTypeId: utmSourceTypeId,
                            utmSourceTypeText: utmSourceTypeText,
                            inputType: inputType
                        });
                    }
                }
            }
            if(sourceTypeIds.length !== selectSourceTypeIds.length){
                toast.error("กรุณาเลือก UTM ให้ครบถ้วน");
                return;
            }

            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setLoading(true);

                            let rebrandlyUrlChecked = document.getElementsByName('rebrandlyUrlChecked');
                            let shortioUrlChecked = document.getElementsByName('shortioUrlChecked');

                            //Main URL
                            let url = refUrl.current.value;
                            if(masterUrlText) {
                                url = masterUrlText;
                            }
                            url = url.toString().trim();

                            //Create Params
                            let params = await Utils.generateParams();
                            params = params + (hashtag ? '#' + hashtag.name:'');
                            let urlParam = url + '?' + params;

                            //Create Short URL (Rebrandly)
                            let rebrandlyUrl = null;
                            if(urlParam && rebrandlyUrlChecked.length && rebrandlyUrlChecked[0].checked)  {
                                const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                rebrandlyUrl = resShortUrl.shortUrl;
                            }

                            //Create Short URL (Short.IO)
                            let shortioUrl = null;
                            if(urlParam && shortioUrlChecked.length && shortioUrlChecked[0].checked)  {
                                const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                shortioUrl = resShortUrl.path;
                            }

                            const body = {
                                typeId: typeId ? typeId.id : null,
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectId: projectId ? projectId.project_code : null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                buTypeId: buTypeId ? buTypeId.id : null,
                                promotionId: promotionId ? promotionId.campaign_id : null,
                                url: url,
                                utmTemplateId: utmTemplateId ? utmTemplateId.id : null,
                                utmGroupId: null,
                                utmGroupItemId: null,
                                hashtag: hashtag ? hashtag.name : null,
                                params: params,
                                shortUrl: rebrandlyUrl,
                                shortioUrl: shortioUrl,
                                masterUrlId: masterUrlId ? masterUrlId.id : null,
                                createdBy: userId,
                                sourceTypeIds: sourceTypeIds
                            };
                            fetch(Config.url.API_URL +'/api/utmGenerate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/utmGenerate', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeHashtag = (obj) => {
        setHashtag(obj);
    };

    const onChangeTypeId = async (obj) => {
        onReset();
        setTypeId(obj);

        if(obj && obj.id === Utils.GENERATE_TYPE_MASTER_URL) {
            setMasterUrlPlaceholder('กำลังโหลด...');
            setDisableMasterUrl(true);
            const resMasterURL = await Utils.getMasterUrl();
            setMasterUrl(resMasterURL);
            setMasterUrlPlaceholder('Select...');
            setDisableMasterUrl(false);
        }

        //get campaign all
        if(obj && (obj.id === Utils.GENERATE_TYPE_SPECIAL || obj.id === Utils.GENERATE_TYPE_MASTER_URL)) {
            setCampaignPlaceholder('กำลังโหลด...');
            setDisableCampaign(true);
            const resCampaign = await Utils.getListSubCampaign();
            if(resCampaign) {
                let campaignList = resCampaign.campaign;
                if(campaignList) {
                    let newCampaign = [];
                    for(let rs of campaignList) {
                        newCampaign.push({
                            campaign_id: rs.sub_campaign_id,
                            campaign_name: rs.sub_campaign_name
                        })
                    }
                    setCampaign(newCampaign);
                    setCampaignPlaceholder('Select...');
                    setDisableCampaign(false);
                }
            }
            else {
                setCampaign(null);
                setCampaignPlaceholder('ไม่พบข้อมูล..');
            }
        }
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setProject('');
        setProjectId(null);
        setProjectPlaceholder('...');
        setDisableProject(true);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);

        refUrl.current.value = '';
    };

    const onChangeProjectTypeId = (obj) => {
        setProjectTypeId(obj);
        setProject('');
        setProjectId(null);
        setProjectPlaceholder('...');
        setDisableProject(true);
        refUrl.current.value = '';
    };

    const onChangeProjectId = (obj) => {
        setProjectId(obj);
        refUrl.current.value = obj && obj.project_url? obj.project_url : '';
        setCampaign(null);
        setCampaignId(null);
        setCampaignPlaceholder('...');

        //reset UTM
        setShowUtmListing(false);
        setUtmTemplateId(null);
        setPreview('');
    };

    const onChangeProjectMasterURLId = async (obj) => {
        setProjectId(obj);
        await onChangeTemplateId(utmTemplateId);
    };

    const onChangePromotionId = async (obj) => {
        setPromotionId(obj);
        setProjectTypeId(null);
        setCampaignId(null);
        setShowUtmListing(false);
        setUtmTemplateId(null);

        setPreview('');

        if(obj && obj.campaign_id) {
            setCampaignId({campaign_id: obj.campaign_id, campaign_name: obj.promotion_name});

            obj.new_promotion_slug = await Utils.getPromotionSlug({
                buTypeId: buTypeId.id,
                campaignTypeId: campaignTypeId.id,
                langId: langId.id,
                promotionSlug: obj.promotion_slug
            });
        }
        refUrl.current.value = obj && obj.promotion_url? obj.promotion_url : '';
    };

    const onChangeCampaignDate = (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeCampaignTypeId = (obj) => {
        setCampaignTypeId(obj);
        setCampaign(null);
        setCampaignId(null);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeBuTypeId = (obj) => {
        setBuTypeId(obj);
        setCampaign(null);
        setCampaignId(null);
        setProjectTypeId(null);

        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);
    };

    const onChangeTemplateId = async (obj) => {
        setShowUtmListing(false);
        setUtmTemplateId(obj);
        setPreview('');

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.id);
            setTemplateSource(resSource);
            const resUtm = await Utils.getUtmByIds(resSource);
            setUtm(resUtm);
            setShowUtmListing(true);

            if(resSource.length > 0) {
                //example
                for(let utm of resUtm) {
                    if(resSource) {
                        let ex = [];
                        for(let rs of resSource) {
                            if(utm.id === rs.utmId) {
                                ex.push('{' + rs.source.name + '}');
                            }
                        }
                        utm.example = ex.join('_');
                    }
                }

                resSource.map( async (rs, idx) => {
                    if(rs.source.inputType === Utils.API_TYPE_CONTENT_ID) {
                        const resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                        let newContentId = [];
                        if(resContentId) {
                            for(let row of resContentId) {
                                newContentId.push({
                                    id: row.id,
                                    xid: row.id + ':CID' + rs.source.id,
                                    name:  Utils.contentIdGenerater(row)
                                });
                            }
                        }
                        setContentId(newContentId);
                    }
                    else if(rs.source.inputType === Utils.API_TYPE_OWNER_ID) {
                        const resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
                        let newOwnerId = [];
                        if(resOwnerId) {
                            for(let row of resOwnerId) {
                                newOwnerId.push({
                                    id: row.id,
                                    xid: row.id + ':OID' + rs.source.id,
                                    name: row.code.charAt(0) + ' : ' + row.name
                                });
                            }
                        }
                        setOwnerId(newOwnerId);
                    }
                });

                //check is template use project
                if(typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL) {
                    for(let rs of resSource) {
                        if(rs.source.inputType === Utils.API_TYPE_PROJECT_SLUG
                        || rs.source.inputType === Utils.API_TYPE_PROJECT_ID
                        || rs.source.inputType === Utils.API_TYPE_PROJECT_NAME
                        || rs.source.inputType === Utils.API_TYPE_LINE_OAID
                        ) {
                            setShowProjectMasterURL(true);
                            break;
                        }
                    }
                }
            }
        }
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
        setShowUtmListing(false);
        setUtmTemplateId(null);

        if(typeId && typeId.id === Utils.GENERATE_TYPE_SPECIAL) {
            setUtmTemplateId(null);
        }
    };

    const onChangeMasterURLId = (obj) => {
        setMasterUrlId(null);
        refUrl.current.value = '';
        if(obj) {
            setMasterUrlId(obj);
            setMasterUrlText(obj.url);
        }
    };

    const onReset = () => {
        setLanguageId(null);
        setCampaignDate(null);
        setTypeId(null);
        setProjectTypeId(null);
        setProjectId(null);
        setCampaignId(null);
        setCampaignTypeId(null);
        setBuTypeId(null);
        setPromotionId(null);
        setUtmTemplateId(null);
        setShowUtmListing(false);

        setDisableProject(true);
        setDisablePromotion(true);
        setDisableCampaign(true);
        setProjectPlaceholder('...');
        setPromotionPlaceholder('...');
        setCampaignPlaceholder('...');

        setMasterUrl(null);
        setMasterUrlId(null);
        setMasterUrlText(null);
    };

    const onPreviewUTM = async () => {
        setPreviewing(true);
        let params = await Utils.generateParams({langId: langId, typeId: typeId, campaignTypeId: campaignTypeId, buTypeId: buTypeId});

        let url = refUrl ? refUrl.current.value : '';
        if(masterUrlText) {
            url = masterUrlText;
        }

        let previewUrl = (url ? url.toString().trim() + '?':'') + params + (hashtag ? '#' + hashtag.name:'');

        setPreviewing(false);
        setPreview(previewUrl);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate UTM</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-8">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    value={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_MASTER_URL) ? 'col-12':'d-none'}>
                                <label htmlFor="masterURLId" className="form-label">Master URL <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableMasterUrl}
                                    placeholder={masterUrlPlaceholder}
                                    classNamePrefix="form-select-search"
                                    options={masterUrl}
                                    onChange={(event) => onChangeMasterURLId(event)}
                                    value={masterUrlId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                                />
                            </div>
                            {
                                typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) ?
                                    <div className="col-12">
                                        <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                        <Select
                                            isClearable={true}
                                            classNamePrefix="form-select-search"
                                            options={lang}
                                            onChange={(event) => onChangeLanguageId(event)}
                                            value={langId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div> : ''
                            }
                            {
                                typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT) ?
                                    <>
                                    <div className="col-12">
                                        <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                        <Select
                                            isClearable={true}
                                            classNamePrefix="form-select-search"
                                            options={projectType}
                                            onChange={(event) => onChangeProjectTypeId(event)}
                                            value={projectTypeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                                        <Select
                                            isClearable={true}
                                            isDisabled={disableProject}
                                            classNamePrefix="form-select-search"
                                            placeholder={projectPlaceholder}
                                            options={project}
                                            onChange={(event) => onChangeProjectId(event)}
                                            value={projectId}
                                            getOptionValue={(option) => `${option.project_code}`}
                                            getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                        />
                                    </div>
                                    </> : ''
                            }

                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={campaignType}
                                    onChange={(event) => onChangeCampaignTypeId(event)}
                                    value={campaignTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={buType}
                                    onChange={(event) => onChangeBuTypeId(event)}
                                    value={buTypeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                                <DatePicker
                                    selected={campaignDate}
                                    onChange={(date) => onChangeCampaignDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROJECT || typeId.id === Utils.GENERATE_TYPE_SPECIAL || typeId.id === Utils.GENERATE_TYPE_MASTER_URL) ? 'col-12':'d-none'}>
                                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableCampaign}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.campaign_id}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                />
                            </div>
                            <div className={typeId && (typeId.id === Utils.GENERATE_TYPE_PROMOTION) ? 'col-12':'d-none'}>
                                <label htmlFor="promotionId" className="form-label">Promotion ID <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    isDisabled={disablePromotion}
                                    placeholder={promotionPlaceholder}
                                    options={promotion}
                                    onChange={(event) => onChangePromotionId(event)}
                                    value={promotionId}
                                    getOptionValue={(option) => `${option.promotion_url}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name} : ${option.project_type_slug}`}
                                />
                            </div>
                            <div className={"col-12 mt-4" + (typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? ' d-none' : '')}>
                                <div className="border rounded bg-green-light p-2">
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                                            <textarea className="form-control" id="url" ref={refUrl} rows={5}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={!typeId || (typeId.id === Utils.GENERATE_TYPE_PROJECT && (!langId || !projectTypeId || !projectId || !campaignId)) || (typeId.id === Utils.GENERATE_TYPE_PROMOTION && (!langId || !campaignTypeId || !buTypeId || !promotionId))}
                                    classNamePrefix="form-select-search"
                                    options={utmTemplate}
                                    onChange={(event) => onChangeTemplateId(event)}
                                    value={utmTemplateId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            {// check is line oa
                                typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL && showProjectMasterURL ?
                                    <>
                                        <div className="col-12">
                                            <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={lang}
                                                onChange={(event) => onChangeLanguageId(event)}
                                                value={langId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={projectType}
                                                onChange={(event) => onChangeProjectTypeId(event)}
                                                value={projectTypeId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                isDisabled={disableProjectMasterURL}
                                                classNamePrefix="form-select-search"
                                                placeholder={projectMasterURLPlaceholder}
                                                options={projectMasterURL}
                                                onChange={(event) => onChangeProjectMasterURLId(event)}
                                                value={projectId}
                                                getOptionValue={(option) => `${option.project_code}`}
                                                getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                                            />
                                        </div>
                                    </> : ''
                            }

                            {/* ---- UTM */}
                            <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                {
                                    utm.length <= 0 ? '' :
                                        utm.map((row, index) => {
                                            return (
                                                showUTMListing ? <div key={index} className={"border rounded bg-yellow-light p-2" + (index+1 !== utm.length ? ' mb-3' : '')}>
                                                    <div className="d-block fw-bold">{(row.utmPrefix === 1 ? 'utm_':'') + row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                    <div className="d-block mb-1 small">{row.example}</div>
                                                    {
                                                        templateSource.length <= 0 ? (<p>ไม่พบข้อมูล source</p>) :
                                                            templateSource.map((rs, index2) => {
                                                                if(rs.source && rs.utmId === row.id) {
                                                                    let isClearable = true;
                                                                    let rsSource = rs.source.sourceType;
                                                                    let inputType = rs.source.inputType;
                                                                    let selected = null;
                                                                    let canBeSelect = false;

                                                                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                        if(contentId) {
                                                                            rsSource = contentId;
                                                                            for(let cs of rsSource) {
                                                                                cs.id = cs.xid;
                                                                            }
                                                                            canBeSelect = true;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                        if(ownerId) {
                                                                            rsSource = ownerId;
                                                                            for(let cs of rsSource) {
                                                                                cs.id = cs.xid;
                                                                            }
                                                                            canBeSelect = true;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {
                                                                        isClearable = false;
                                                                        if(campaignId) {
                                                                            selected = {
                                                                                id: campaignId.campaign_id + ':CP' + rs.source.id,
                                                                                name: campaignId.campaign_id
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {
                                                                        isClearable = false;
                                                                        if(campaignId) {
                                                                            selected = {
                                                                                id: campaignId.campaign_name + ':CN' + rs.source.id,
                                                                                name: campaignId.campaign_name
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                                        isClearable = false;
                                                                        rsSource = [];
                                                                        if(projectId) {
                                                                            selected = {
                                                                                id: projectId.project_code + ':PJI' + rs.source.id,
                                                                                name: projectId.project_code
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                                        isClearable = false;
                                                                        if(projectId) {
                                                                            let projectName = langId.id + '-' + projectId.project_type_slug + '-' + projectId.project_slug;
                                                                            selected = {
                                                                                id: projectName + ':PJN' + rs.source.id,
                                                                                name: projectName
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                                        isClearable = false;
                                                                        if(projectId) {
                                                                            selected = {
                                                                                id: projectId.project_slug + ':PJS' + rs.source.id,
                                                                                name: projectId.project_slug
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                                        isClearable = false;
                                                                        if(promotionId && promotionId.new_promotion_slug) {
                                                                            selected = {
                                                                                id: promotionId.new_promotion_slug + ':PMS' + rs.source.id,
                                                                                name: promotionId.new_promotion_slug
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                                        isClearable = false;
                                                                        if(projectId) {
                                                                            selected = {
                                                                                id: projectId.line_oaid + ':LINEOA' + rs.source.id,
                                                                                name: projectId.project_title
                                                                            };
                                                                            rsSource = selected;
                                                                        }
                                                                    }
                                                                    else {
                                                                        canBeSelect = true;
                                                                    }

                                                                    return (
                                                                        <div key={index2} className="ms-2 mt-3">
                                                                            <div className="row mt-2">
                                                                                <div className="col-12 col-sm-4 text-end small">
                                                                                    {rs.source.name} :
                                                                                    {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <div><span className="badge bg-secondary small">encrypt</span></div>:''}
                                                                                </div>
                                                                                <div className="col-12 col-sm-8">
                                                                                    <span className="text-muted small fw-light">{
                                                                                        inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                            '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                    }</span>
                                                                                    <Select
                                                                                        isClearable={isClearable}
                                                                                        isSearchable={isClearable}
                                                                                        name="sourceTypeIds[]"
                                                                                        classNamePrefix="form-select-search"
                                                                                        placeholder={rsSource.length ? 'Select...':'...'}
                                                                                        defaultValue={selected}
                                                                                        options={canBeSelect ? rsSource : [rsSource]}
                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })
                                                    }
                                                </div> : ''
                                            );
                                        })
                                }
                            </div>

                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={hashtagList}
                                    onChange={(event) => onChangeHashtag(event)}
                                    value={hashtag}
                                    getOptionValue={(option) => `${option.name}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            <div className="col-12">
                                <div className="border rounded bg-green-light p-2 mb-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onPreviewUTM} disabled={utmTemplateId == null || previewing}>Preview</button> <span
                                                className={previewing ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span></label>
                                            <div className="noselect-url w100 rounded">{preview}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" id="rebrandlyUrl" defaultChecked={false} />
                                    <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                </div>
                            </div>

                            <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="shortioUrlChecked" id="shortioUrl" defaultChecked={false} />
                                    <label className="form-check-label" htmlFor="shortioUrl"></label>
                                </div>
                            </div>
                            
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/utmGenerate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 